












import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { CurveLayer } from '@/model/document2/page/surface/design/layer/curveLayer';
import { Vector2 } from '@/utilityModels/vector2';

import { UserAgentHelper } from '@/helper/userAgentHelper';

@Component({
    components: {
    },
})
export default class CurveController extends Vue 
{
    private get isMobile() { return UserAgentHelper.isMobile(); }

    // 円の半径
    CIRCLE_RADIUS : number = 5;

    @Prop() private layer! : Layer | null;
    @Prop() private scale! : number;
    @Prop() private cursorWidth! : number;
    @Prop() private cursorHeight! : number;
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;

    private get pointArray()
    {
        if(this.layer == null || !(this.layer instanceof CurveLayer)) { return []; }
        var pointArray : Array<{point : Vector2, index: number}> = new Array();
        for(var i = 0; i < this.layer.getControlPointsNumber(); ++i)
        {
            pointArray.push({point : this.layer.getControlPoint(i), index: i});
        }
        return pointArray;
    }
    private getX(point : Vector2)
    {
        return point.x * this.scale + this.offsetX;
    }

    private getY(point : Vector2)
    {
        return point.y * this.scale + this.offsetY;
    }

    private get r()
    {
        return this.cursorWidth / 2;
    }

    private selectPoint(index)
    {
        if(this.layer == null || !(this.layer instanceof CurveLayer)) { return; }
        if(!UserAgentHelper.isMobile())
        {
            this.layer.isTouched = true;
        }

        this.$emit("selectPoint", index);
    }

    private unselectPoint()
    {
        if(this.layer == null || !(this.layer instanceof CurveLayer)) { return; }
        this.layer.isTouched = false;
    }

}
